export default __webpack_public_path__ + "static/media/Guru-Parampara-15.55718f6d.png";